var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Field } from "@atlassiansox/microscopekit";
import { ErrorMessage } from "@atlaskit/form";
import Select from "@atlaskit/select";
import { differenceBy } from "lodash";
import { useImportWargamePlan } from "./useImportWargamePlan";
import { validators } from "../../../utils";
import { FormModal } from "../../../components";
export var ImportWargamePlan = function (_a) {
    var isVisible = _a.isVisible, onHide = _a.onHide, serviceId = _a.serviceId, exerciseId = _a.exerciseId, existingWargamePlans = _a.existingWargamePlans;
    var _b = useImportWargamePlan(serviceId, onHide), wargameTemplates = _b.wargameTemplates, isWargameTemplatesLoading = _b.isWargameTemplatesLoading, importWargamePlan = _b.importWargamePlan, isImportingWargamePlan = _b.isImportingWargamePlan;
    var onSubmit = function (formValue) {
        return importWargamePlan(formValue.wargameTemplate.value, exerciseId);
    };
    var eligibleWargamePlans = differenceBy(wargameTemplates, existingWargamePlans, function (wargamePlan) { return wargamePlan.id; });
    return (React.createElement(FormModal, { width: "small", isOpen: isVisible, heading: "Import Wargame Plan", actions: {
            submit: {
                text: "Import",
                onSubmit: onSubmit,
                isSubmitting: isImportingWargamePlan
            },
            close: {
                text: "Cancel",
                onClose: onHide
            }
        } },
        React.createElement(Field, { name: "wargameTemplate", label: "Wargame Template", isRequired: true, isDisabled: isWargameTemplatesLoading, validate: validators.required }, function (_a) {
            var fieldProps = _a.fieldProps, error = _a.error;
            return (React.createElement(React.Fragment, null,
                React.createElement(Select, __assign({}, fieldProps, { isLoading: isWargameTemplatesLoading, menuPosition: "fixed", options: eligibleWargamePlans.map(function (_a) {
                        var id = _a.id, name = _a.name;
                        return ({
                            label: name,
                            value: id
                        });
                    }) })),
                error && React.createElement(ErrorMessage, null, error)));
        }),
        React.createElement("br", null)));
};
